import React from "react";
import {cloneDeep} from "lodash";
import {
    ActionButton,
    DetailsList,
    DetailsListLayoutMode,
    IColumn,
    IconButton,
    SelectionMode,
    TextField
} from "@fluentui/react";
import AttributeDivider from "../Common/AttributeDivider";
import Accordion from "../Common/Accordion";

interface IProductLinesTableProps {
    title?: string;
    productLines: string[];
    editMode?: boolean;
    onUpdate?: (productLines: string[]) => void;
}

export interface IAttributeKV {
    key: string;
    value: string | number | undefined;
}

export const ProductLinesTable: React.FC<IProductLinesTableProps> = (props) => {
    const updateProductLine = (i: number, value: string) => {
        if (!props.onUpdate) return;
        const newProductLines = cloneDeep(props.productLines);
        newProductLines[i] = value;
        props.onUpdate(newProductLines);
    }

    const addProductLine = () => {
        if (!props.onUpdate) return;
        const newProductLine = cloneDeep(props.productLines);
        //Have to push an empty space, otherwise DetailsList will not render TextField control
        newProductLine.push(' ');
        props.onUpdate(newProductLine);
    }

    const deleteProductLine = (i: number | undefined) => {
        if (!props.onUpdate) return;
        if (i === undefined) return;
        const newProductLines = cloneDeep(props.productLines);
        newProductLines.splice(i, 1);
        props.onUpdate(newProductLines);
    }

    if (props.productLines.length === 0 && !props.editMode) return null;

    return (
    <Accordion useChevron={true} titleComponent={<h3>{props.title}</h3>} beginExpanded={true} indentWidth={10}>
        <div>
            {(props.productLines && props.productLines.length > 0) && 
            <div className={"ac-attribute-segment"}>
                {props.productLines.map((item, i) => (
                    <div key={i} style={{ marginBottom: 12, display: 'flex', flexDirection: 'row' }}>
                        <div style={{minWidth: '100px', width: '25%', paddingRight: '10px'}}>
                            {props.editMode ?
                                <TextField
                                    placeholder={`${props.title ?? 'Attribute'} Key`}
                                    value={item}
                                    onChange={(e, d) => {
                                        updateProductLine(i, d ?? '');
                                    }}
                                />
                                : <>{item}</>}
                        </div>
                        <div>
                            {props.editMode ? <IconButton
                                iconProps={{iconName: 'Delete'}}
                                onClick={() => deleteProductLine(i)}
                            /> : <></>}
                        </div>
                    </div>
                ))}
            </div>}
            <div>
                {props.editMode && <ActionButton
                    label={'Add Product Line'}
                    iconProps={{iconName: 'Add'}}
                    onClick={() => addProductLine()}
                >Add Product Line</ActionButton>}
            </div>
        </div>
    </Accordion>)
};
